import React from 'react';
import { Stack, Typography } from '@mui/material';

export default function NotFound() {
  return (
    <Stack p={1} flex={1} rowGap={1} bgcolor="background.paper" alignItems="center" justifyContent="center">
      <Typography variant="caption" color="textDisabled">
        محصولی برای این بن تعریف نشده است.
      </Typography>
    </Stack>
  );
}
